import ImageGallery from "components/gallery/Gallery";
import DefaultNavbar from "components/DefaultNavbar";
import DefaultFooter from "components/DefaultFooter";
import Title from "components/landing/Title";

export default function Gallery() {
    return (
        <>
            <DefaultNavbar />
            <main>
                <section className="pt-8 pb-16 bg-gray-100">
                    <div className="container max-w-7xl mx-auto px-4">
                        <Title heading="Gallery">
                            A look at Rise Up Prison Ministry through photos.
                        </Title>
                        <ImageGallery />
                    </div>
                </section>
            </main>
            <DefaultFooter />
        </>
    );
}